export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Po zakończeniu transakcji zostanie ona zamknięta. Środki wewnętrzne zostaną przekazane użytkownikowi."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czy na pewno chcesz zakończyć transakcję?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, zakończ"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie, pozostaw aktywną"])}
}